<template>
  <el-dialog
    title="Create New LP Lock"
    :visible.sync="visible"
    width="540px"
    class="lock-dialog"
  >
    <el-form
      ref="form"
      v-loading.lock="loading"
      :model="form"
      label-position="top"
      hide-required-asterisk
    >
      <div v-if="step === 1">
        <p style="color: var(--color-subheading-text)">
          Search for the LP Pair you want to lock liquidity for.
        </p>
        <el-form-item prop="lpTokenAddress">
          <el-autocomplete
            v-model="form.lpTokenSearch"
            class="el-input"
            :fetch-suggestions="queryLpTokens"
            :trigger-on-focus="false"
            placeholder="Search for LP Token"
            @select="handleLpTokenSelect"
          >
            <template slot-scope="{ item }">
              <div style="padding: 6px 0">
                <!-- <el-avatar
                  shape="circle"
                  :size="40"
                  style="
                    position: relative;
                    border: 4px solid #fff;
                    vertical-align: middle;
                  "
                  src="data:image/png;base64,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"
                ></el-avatar> -->
                <el-avatar
                  v-if="
                    Array.isArray(item.thumbnailUri) &&
                    item.thumbnailUri.length > 0
                  "
                  :src="item.thumbnailUri[0]"
                  fit="cover"
                  shape="circle"
                  :size="40"
                  style="
                    position: relative;
                    border: 4px solid #fff;
                    vertical-align: middle;
                    margin-left: -18px;
                    margin-right: 14px;
                  "
                ></el-avatar>
                <el-avatar
                  v-if="
                    Array.isArray(item.thumbnailUri) &&
                    item.thumbnailUri.length > 0
                  "
                  :src="item.thumbnailUri[1]"
                  fit="cover"
                  shape="circle"
                  :size="40"
                  style="
                    position: relative;
                    border: 4px solid #fff;
                    vertical-align: middle;
                    margin-left: -18px;
                    margin-right: 14px;
                  "
                ></el-avatar>
                {{ item.value }}
              </div>
            </template>
          </el-autocomplete>
        </el-form-item>

        <div
          v-if="form.lpTokenAddress"
          style="font-weight: bold; margin-bottom: 12px"
        >
          PAIR FOUND
        </div>
        <div
          v-if="form.lpTokenAddress"
          class="current-balance _info-card"
          style="
            border-radius: 12px;
            background: #ffeecc;
            padding: 12px 20px;
            margin-bottom: 18px;
          "
        >
          <el-row type="flex" align="middle" justify="space-between">
            <el-col :span="12" style="font-weight: bold">
              <el-avatar
                v-if="
                  Array.isArray(form.lpTokenThumbnailUri) &&
                  form.lpTokenThumbnailUri.length > 0
                "
                :src="form.lpTokenThumbnailUri[0]"
                fit="cover"
                shape="circle"
                :size="32"
                style="
                  position: relative;
                  border: 2px solid #fff;
                  vertical-align: middle;
                  margin-left: -14px;
                  margin-right: 12px;
                "
              ></el-avatar>
              <el-avatar
                v-if="
                  Array.isArray(form.lpTokenThumbnailUri) &&
                  form.lpTokenThumbnailUri.length > 0
                "
                :src="form.lpTokenThumbnailUri[1]"
                fit="cover"
                shape="circle"
                :size="32"
                style="
                  position: relative;
                  border: 2px solid #fff;
                  vertical-align: middle;
                  margin-left: -14px;
                  margin-right: 12px;
                "
              ></el-avatar>
              {{ form.lpTokenName }}
            </el-col>
            <el-col
              :span="12"
              style="font-size: 12px; text-align: right; font-weight: bold"
            >
              <span class="_info-card__title">BALANCE: </span>
              {{
                vueNumberFormat(form.lpBalance, {
                  decimal: ".",
                  thousand: ",",
                  precision: 18,
                  prefix: "",
                  suffix: "",
                })
              }}</el-col
            >
          </el-row>
        </div>

        <el-button
          :disabled="!form.lpTokenAddress || form.lpBalance <= 0"
          type="primary"
          style="
            border-radius: 12px;
            font-weight: bold;
            width: 100%;
            padding: 20px;
            margin-left: 0;
          "
          @click="next"
          >CONTINUE</el-button
        >
      </div>

      <div
        v-if="step === 2 && form.lpTokenAddress"
        style="color: var(--color-subheading-text)"
      >
        <p>Enter the below details to proceed.</p>
        <p style="word-break: break-word">
          <strong>Note:</strong> Double check parameters as the tokens can only
          be unlocked after the selected <strong>UNLOCK TIME</strong>
        </p>

        <div
          class="current-balance _info-card"
          style="
            border-radius: 12px;
            background: #ffeecc;
            padding: 12px 20px;
            margin-bottom: 18px;
          "
        >
          <el-row type="flex" align="middle" justify="space-between">
            <el-col :span="12" style="font-weight: bold">
              <el-avatar
                v-if="
                  Array.isArray(form.lpTokenThumbnailUri) &&
                  form.lpTokenThumbnailUri.length > 0
                "
                :src="form.lpTokenThumbnailUri[0]"
                fit="cover"
                shape="circle"
                :size="32"
                style="
                  position: relative;
                  border: 2px solid #fff;
                  vertical-align: middle;
                  margin-left: -14px;
                  margin-right: 12px;
                "
              ></el-avatar>
              <el-avatar
                v-if="
                  Array.isArray(form.lpTokenThumbnailUri) &&
                  form.lpTokenThumbnailUri.length > 0
                "
                :src="form.lpTokenThumbnailUri[1]"
                fit="cover"
                shape="circle"
                :size="32"
                style="
                  position: relative;
                  border: 2px solid #fff;
                  vertical-align: middle;
                  margin-left: -14px;
                  margin-right: 12px;
                "
              ></el-avatar>
              {{ form.lpTokenName }}
            </el-col>
            <el-col
              :span="12"
              style="font-size: 12px; text-align: right; font-weight: bold"
              ><span class="_info-card__title">BALANCE: </span>
              {{
                vueNumberFormat(form.lpBalance, {
                  decimal: ".",
                  thousand: ",",
                  precision: 18,
                  prefix: "",
                  suffix: "",
                })
              }}</el-col
            >
          </el-row>
        </div>

        <el-row type="flex" align="top" :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="Token Amount"
              prop="input"
              :rules="[
                {
                  type: 'number',
                  required: true,
                  message: 'Enter an amount',
                  transform: (v) => Number(v),
                },
                {
                  type: 'number',
                  min: 0.000000000000000001,
                  message: 'Enter a valid amount (at least 0.000001)',
                  transform: (v) => Number(v),
                },
              ]"
              style="margin-bottom: 14px"
            >
              <el-input v-model="form.input" label="Token Amount">
                <span slot="suffix">
                  <el-button
                    type="text"
                    size="small"
                    style="color: #1ec37f; font-weight: bold"
                    @click="form.input = form.lpBalance"
                    >USE MAX</el-button
                  >
                </span>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Unlock Time" prop="unlockTime">
              <el-date-picker
                v-model="form.unlockTime"
                type="datetime"
                placeholder="Select date and time"
                default-time="00:00:00"
              ></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Service Fee Options" prop="serviceFeeId">
          <el-select
            v-model="form.serviceFeeId"
            placeholder="Select Service Fee"
            style="width: 100%"
          >
            <el-option
              v-for="item in serviceFees"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-row type="flex" align="top" :gutter="20">
          <el-col :span="8">
            <el-button
              type="info"
              class="btn-alt__2"
              plain
              style="
                border-radius: 12px;
                font-weight: bold;
                width: 100%;
                padding: 20px;
                margin-left: 0;
              "
              @click="prev"
              >PREVIOUS</el-button
            >
          </el-col>
          <el-col :span="16">
            <el-button
              :disabled="!form.input || !form.serviceFeeId || !form.unlockTime"
              type="primary"
              style="
                border-radius: 12px;
                font-weight: bold;
                width: 100%;
                padding: 20px;
                margin-left: 0;
              "
              @click="next"
              >CONTINUE</el-button
            >
          </el-col>
        </el-row>
      </div>

      <div v-if="step === 3 && form.lpTokenAddress">
        <p style="word-break: break-word">
          <strong>Note:</strong> Double check parameters as the tokens can only
          be unlocked after the selected <strong>UNLOCK TIME</strong>
        </p>
        <h3 style="margin-top: 0">Lock Summary</h3>
        <div
          class="current-balance _info-card"
          style="
            border-radius: 12px;
            background: #ffeecc;
            padding: 12px 20px;
            margin-bottom: 18px;
          "
        >
          <el-row type="flex" align="middle" justify="space-between">
            <el-col :span="12" style="font-weight: bold">
              <el-avatar
                v-if="
                  Array.isArray(form.lpTokenThumbnailUri) &&
                  form.lpTokenThumbnailUri.length > 0
                "
                :src="form.lpTokenThumbnailUri[0]"
                fit="cover"
                shape="circle"
                :size="32"
                style="
                  position: relative;
                  border: 2px solid #fff;
                  vertical-align: middle;
                  margin-left: -14px;
                  margin-right: 12px;
                "
              ></el-avatar>
              <el-avatar
                v-if="
                  Array.isArray(form.lpTokenThumbnailUri) &&
                  form.lpTokenThumbnailUri.length > 0
                "
                :src="form.lpTokenThumbnailUri[1]"
                fit="cover"
                shape="circle"
                :size="32"
                style="
                  position: relative;
                  border: 2px solid #fff;
                  vertical-align: middle;
                  margin-left: -14px;
                  margin-right: 12px;
                "
              ></el-avatar>
              {{ form.lpTokenName }}
            </el-col>
            <el-col
              :span="12"
              style="font-size: 12px; text-align: right; font-weight: bold"
            >
              <span class="_info-card__title">BALANCE:</span>
              {{
                vueNumberFormat(form.lpBalance, {
                  decimal: ".",
                  thousand: ",",
                  precision: 18,
                  prefix: "",
                  suffix: "",
                })
              }}</el-col
            >
          </el-row>
        </div>
        <el-row
          :gutter="20"
          type="flex"
          style="font-size: 14px; margin-bottom: 14px"
        >
          <el-col :span="8" style="font-weight: bold; text-align: right"
            >Amount to Lock:</el-col
          >
          <el-col :span="16">{{ vueNumberFormat(form.input * 1) }}</el-col>
        </el-row>
        <el-row
          :gutter="20"
          type="flex"
          style="font-size: 14px; margin-bottom: 14px"
        >
          <el-col :span="8" style="font-weight: bold; text-align: right"
            >Unlock Time:</el-col
          >
          <el-col :span="16">{{ form.unlockTime }}</el-col>
        </el-row>
        <el-row
          :gutter="20"
          type="flex"
          style="font-size: 14px; margin-bottom: 14px"
        >
          <el-col :span="8" style="font-weight: bold; text-align: right"
            >Service Fee:</el-col
          >
          <el-col :span="16">
            <div v-if="form.serviceFeeId === '0'">10,000 CRNCHY</div>
            <div v-if="form.serviceFeeId === '1'">50,000 CRNCHY</div>
            <div v-if="form.serviceFeeId === '2'">100,000 CRNCHY</div>
            <div v-if="form.serviceFeeId === '3'">500,000 CRNCHY</div>

            <div v-if="form.serviceFeeId === '0'">
              {{ vueNumberFormat(form.input * 0.015) }} {{ form.lpTokenName }}
            </div>
            <div v-if="form.serviceFeeId === '1'">
              {{ vueNumberFormat(form.input * 0.01) }} {{ form.lpTokenName }}
            </div>
            <div v-if="form.serviceFeeId === '2'">
              {{ vueNumberFormat(form.input * 0.005) }} {{ form.lpTokenName }}
            </div>
          </el-col>
        </el-row>

        <el-alert
          v-if="form.serviceFeeId === '0'"
          :title="`Upon unlock, you will receive back ${vueNumberFormat(
            form.input - form.input * 0.015
          )} ${form.lpTokenName} LP tokens.`"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <el-alert
          v-if="form.serviceFeeId === '1'"
          :title="`Upon unlock, you will receive back ${vueNumberFormat(
            form.input - form.input * 0.01
          )} ${form.lpTokenName} LP tokens.`"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>
        <el-alert
          v-if="form.serviceFeeId === '2'"
          :title="`Upon unlock, you will receive back ${vueNumberFormat(
            form.input - form.input * 0.005
          )} ${form.lpTokenName} LP tokens.`"
          type="info"
          show-icon
          :closable="false"
        >
        </el-alert>

        <el-row type="flex" align="top" :gutter="20" style="margin-top: 14px">
          <el-col :span="8">
            <el-button
              type="info"
              plain
              class="btn-alt__2"
              style="
                border-radius: 12px;
                font-weight: bold;
                width: 100%;
                padding: 20px;
                margin-left: 0;
              "
              @click="prev"
              >PREVIOUS</el-button
            >
          </el-col>
          <el-col :span="16">
            <el-button
              type="primary"
              style="
                border-radius: 12px;
                font-weight: bold;
                width: 100%;
                padding: 20px;
                margin-left: 0;
              "
              @click="createLock"
              >CREATE LOCK</el-button
            >
          </el-col>
        </el-row>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ipfs from "./../utils/ipfs";
import farmUtils from "./../utils/farm";

export default {
  name: "LpLockerCreateDialog",
  data() {
    return {
      form: {
        input: "",
        lpTokenSearch: "",
        lpTokenType: "",
        lpTokenAddress: "",
        lpTokenId: "",
        lpTokenName: "",
        lpTokenThumbnailUri: "",
        lpBalance: 0,
        unlockTime: "",
        serviceFeeId: "",
      },
      step: 1,
      loading: false,
      visible: false,
      serviceFees: [
        { value: "0", label: "10,000 CRNCHY + 1.5% of tokens" },
        { value: "1", label: "50,000 CRNCHY + 1.0% of tokens" },
        { value: "2", label: "100,000 CRNCHY + 0.5% of tokens" },
        { value: "3", label: "500,000 CRNCHY + 0% of tokens" },
      ],
      rules: {
        unlockTime: [
          { required: true, message: "Select an unlock date & time" },
        ],
        serviceFeeId: [{ required: true, message: "Select a service fee" }],
      },
    };
  },
  computed: {
    ...mapState(["lpLockers"]),
  },
  methods: {
    ...mapActions(["createLpLock", "getLpBalance", "updateLpCurrentPrices"]),

    next() {
      this.step++;
    },

    prev() {
      this.step--;
    },

    async showDialog() {
      this.step = 1;
      this.form.input = "";
      this.form.lpTokenSearch = "";
      this.form.lpTokenAddress = "";
      if (Object.prototype.hasOwnProperty.call(this.$refs, "form")) {
        this.$refs.form.resetFields();
      }
      this.loading = true;
      this.visible = true;

      const vm = this;
      this.updateLpCurrentPrices().then(() => {
        vm.loading = false;
      });
    },

    queryLpTokens(keywords, cb) {
      const matches = [];

      // liquidity baking
      if (
        "liquidity baking lb".includes(keywords.toLowerCase()) ||
        "tzbtc".includes(keywords.toLowerCase())
      ) {
        matches.push({
          value: "XTZ/tzBTC (Liquidity Baking)",
          type: "fa1",
          address: "KT1AafHA1C1vk959wvHWBispY9Y2f3fxBUUo",
          tokenId: 0,
          thumbnailUri:
            "https://tzbtc.io/wp-content/uploads/2020/03/tzbtc_logo_single.svg",
        });
      }

      for (let t of this.lpLockers.lpTokens) {
        if (
          (Object.prototype.hasOwnProperty.call(t, "name") &&
            t?.name?.toLowerCase().includes(keywords.toLowerCase())) ||
          (Object.prototype.hasOwnProperty.call(t, "symbol") &&
            t?.symbol?.toLowerCase().includes(keywords.toLowerCase())) ||
          (Object.prototype.hasOwnProperty.call(t, "tokenAddress") &&
            t?.tokenAddress?.toLowerCase().includes(keywords.toLowerCase()))
        ) {
          t = farmUtils.overrideMetadata(t);
          if (
            !Object.prototype.hasOwnProperty.call(t, "thumbnailUri") ||
            t.thumbnailUri === null ||
            !t.thumbnailUri
          ) {
            t.thumbnailUri =
              "https://static.thenounproject.com/png/796573-200.png";
          }
          t.thumbnailUri = ipfs.transformUri(t.thumbnailUri);
          const tokenPools = this.lpLockers.tokenPools.filter(
            (el) =>
              el.lpToken?.tokenAddress === t.tokenAddress &&
              el.lpToken?.tokenId === t.tokenId
          );
          const thumbnailUris = tokenPools[0]?.tokens.map((el) =>
            el?.token?.thumbnailUri !== null
              ? ipfs.transformUri(el.token.thumbnailUri)
              : el.token.thumbnailUri
          );
          const dexType = tokenPools[0]?.dex?.type;

          matches.push({
            value: t.symbol || t.name,
            type: t.tokenType,
            address: t.tokenAddress,
            tokenId: t.tokenId || 0,
            isLp: true,
            dexType: dexType,
            thumbnailUri: thumbnailUris,
          });
        }
      }

      cb(matches);
    },

    handleLpTokenSelect(i) {
      this.form.lpTokenName = i.value;
      this.form.lpTokenType = i.type === "fa2" ? "fa2" : "fa1";
      this.form.lpTokenAddress = i.address;
      this.form.lpTokenId = i.type === "fa2" ? i.tokenId : "";
      this.form.lpTokenThumbnailUri = i.thumbnailUri;
      this.form.lpDexType = i.dexType;
      this.loading = true;
      this.getLpBalance({
        tokenAddress: i.address,
        tokenId: i.type === "fa2" ? i.tokenId : "",
        dexType: i.dexType,
      }).then((bal) => {
        this.form.lpBalance = bal;
        this.loading = false;
      });
    },

    async createLock() {
      const vm = this;
      this.$refs.form.validate((valid) => {
        if (valid) {
          vm.loading = true;
          vm.createLpLock({
            amount: vm.form.input,
            serviceFeeId: vm.form.serviceFeeId,
            lockEndTime: vm.form.unlockTime,
            lpToken: {
              tokenType: vm.form.lpTokenType,
              address: vm.form.lpTokenAddress,
              tokenId: vm.form.lpTokenId || 0,
            },
            dexType: vm.form.lpDexType,
          }).then(() => {
            vm.visible = false;
            vm.loading = false;
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../crunchy-variables.scss";
@import "~element-ui/packages/theme-chalk/src/common/var";
</style>
